"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichJurisdictionRequirementsWithHazardData = exports.getCityHelper = exports.fetchHazardData = exports.getJurisdictionDataFromDocData = void 0;
const core_1 = require("@natomas-org/core");
const ArcGIS_1 = require("../../ArcGIS");
const { queryFeatures } = require("@esri/arcgis-rest-feature-layer");
const getJurisdictionDataFromDocData = (docData) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (docData !== null && docData.length > 0) {
        const fieldMatches = [];
        if (docData[0].max_size_sqft !== null) {
            fieldMatches.push("maxADUSqFt");
        }
        else if (docData[0].bed_max_size_2_sqft !== null) {
            fieldMatches.push("maxADUSqFt");
        }
        if (docData[0].max_bedrooms !== null) {
            fieldMatches.push("maxBedrooms");
        }
        if (docData[0].side_and_rear_setbacks_ft !== null) {
            fieldMatches.push("sideAndRearSetBacks");
        }
        if (docData[0].primary_residence_setback_ft !== null) {
            fieldMatches.push("primarySetBacks");
        }
        return {
            placementConstraints: {
                primarySetBacks: (_a = docData[0].primary_residence_setback_ft) !== null && _a !== void 0 ? _a : undefined,
                sideAndRearSetBacks: (_b = docData[0].side_and_rear_setbacks_ft) !== null && _b !== void 0 ? _b : undefined,
                frontSetback: docData[0].front_setback_ft,
            },
            productConstraints: {
                maxADUSqFt: (_c = docData[0].max_size_sqft) !== null && _c !== void 0 ? _c : undefined,
                maxBedrooms: (_d = docData[0].max_bedrooms) !== null && _d !== void 0 ? _d : undefined,
            },
            jurisdiction: {
                jurisdictionId: (_e = docData[0].objectId) !== null && _e !== void 0 ? _e : undefined,
                jurisdictionName: (_f = docData[0].city) !== null && _f !== void 0 ? _f : undefined,
            },
            requirements: {
                approvalReqs: (_g = docData[0].approval_requirements) !== null && _g !== void 0 ? _g : [],
                submittalReqs: (_h = docData[0].submittal_requirements) !== null && _h !== void 0 ? _h : [],
                fieldMatches: fieldMatches,
            },
        };
    }
    else {
        return null;
    }
};
exports.getJurisdictionDataFromDocData = getJurisdictionDataFromDocData;
const fetchHazardData = async (coordinateRequest) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!coordinateRequest) {
        return null;
    }
    const seismicResponse = (0, ArcGIS_1.getAllSeismicData)(coordinateRequest);
    const fireHazardZoneSRA = (0, ArcGIS_1.queryFireHazardSafetyZoneSRA)(coordinateRequest);
    const fireHazardZoneLRA = (0, ArcGIS_1.queryFireHazardSafetyZoneLRA)(coordinateRequest);
    const floodZone = (0, ArcGIS_1.queryPublicFloodZone)(coordinateRequest, core_1.FEMA_GIS_LAYER_URL);
    await Promise.all([
        floodZone,
        seismicResponse,
        fireHazardZoneLRA,
        fireHazardZoneSRA,
    ]);
    return {
        floodZone: await floodZone,
        liquefactionZone: (_b = (_a = (await seismicResponse)) === null || _a === void 0 ? void 0 : _a.LiquefactionZone) !== null && _b !== void 0 ? _b : null,
        landslideZone: (_d = (_c = (await seismicResponse)) === null || _c === void 0 ? void 0 : _c.LandslideZone) !== null && _d !== void 0 ? _d : null,
        faultZone: (_f = (_e = (await seismicResponse)) === null || _e === void 0 ? void 0 : _e.FaultZone) !== null && _f !== void 0 ? _f : null,
        fireHazardRatingLRA: (_g = (await fireHazardZoneLRA)) !== null && _g !== void 0 ? _g : null,
        fireHazardRatingSRA: (_h = (await fireHazardZoneSRA)) !== null && _h !== void 0 ? _h : null,
    };
};
exports.fetchHazardData = fetchHazardData;
// Retrieves the jurisdiction/city from a public layer.
const getCityHelper = (request) => {
    return queryFeatures({
        url: core_1.CITIES_COUNTIES_GIS_LAYER_URL,
        geometry: {
            x: Number(request.long),
            y: Number(request.lat),
            spatialReference: {
                wkid: 4326,
            },
        },
        geometryType: "esriGeometryPoint",
        spatialRel: "esriSpatialRelIntersects",
        returnGeometry: true,
        outFields: ["CITY", "COUNTY"],
        f: "geojson",
    })
        .then((response) => {
        var _a;
        if (!(response === null || response === void 0 ? void 0 : response.features) ||
            ((_a = response === null || response === void 0 ? void 0 : response.features) === null || _a === void 0 ? void 0 : _a.length) < 1 ||
            !(response === null || response === void 0 ? void 0 : response.features[0].properties["CITY"]) ||
            !(response === null || response === void 0 ? void 0 : response.features[0].properties["COUNTY"])) {
            return null;
        }
        let cityHelper;
        const city = response === null || response === void 0 ? void 0 : response.features[0].properties["CITY"];
        if (city.trim().toLowerCase() !== "unincorporated") {
            cityHelper = city;
        }
        else {
            const county = response === null || response === void 0 ? void 0 : response.features[0].properties["COUNTY"];
            cityHelper = `${county.trim()} Unincorporated`; // ex: 'Marin County Unincorporated'
        }
        return cityHelper.toUpperCase();
    })
        .catch((e) => {
        console.log("AHJ Error: " + e);
        return null;
    });
};
exports.getCityHelper = getCityHelper;
const enrichJurisdictionRequirementsWithHazardData = async (jurisdictionData, hazardData) => {
    var _a;
    const enrichedJurisdictionData = Object.assign({ requirements: {} }, jurisdictionData);
    // June 22, '22
    if ((hazardData === null || hazardData === void 0 ? void 0 : hazardData.faultZone) || (hazardData === null || hazardData === void 0 ? void 0 : hazardData.landslideZone)) {
        //  Fault Zone and Landslide Zone Parcels require a "SOILS REPORT".
        enrichedJurisdictionData.requirements.approvalReqs =
            appendToJurisdictionApprovalReqs(jurisdictionData, core_1.SOILS_REPORT_ID);
    }
    if (((_a = hazardData === null || hazardData === void 0 ? void 0 : hazardData.floodZone) === null || _a === void 0 ? void 0 : _a.charAt(0)) === "A") {
        //  If in a flood zone that starts with letter "A", then add "ELEVATION CERTIFICATE" to Phase 1 costs
        enrichedJurisdictionData.requirements.approvalReqs =
            appendToJurisdictionApprovalReqs(jurisdictionData, core_1.ELEVATION_CERTIFICATE_ID);
    }
    if (((hazardData === null || hazardData === void 0 ? void 0 : hazardData.fireHazardRatingLRA) &&
        (hazardData === null || hazardData === void 0 ? void 0 : hazardData.fireHazardRatingLRA) !== core_1.FireHazardRating.NONE) ||
        ((hazardData === null || hazardData === void 0 ? void 0 : hazardData.fireHazardRatingSRA) &&
            (hazardData === null || hazardData === void 0 ? void 0 : hazardData.fireHazardRatingSRA) !== core_1.FireHazardRating.NONE)) {
        //  If in a fire zone  Add "VEGETATION MANAGEMENT PLAN" to Phase 1, and maybe a note to the customer.
        enrichedJurisdictionData.requirements.approvalReqs =
            appendToJurisdictionApprovalReqs(jurisdictionData, core_1.VEGETATION_MANAGEMENT_ID);
    }
    return enrichedJurisdictionData;
};
exports.enrichJurisdictionRequirementsWithHazardData = enrichJurisdictionRequirementsWithHazardData;
const appendToJurisdictionApprovalReqs = (jurisdictionData, requirement) => {
    var _a, _b, _c, _d, _e, _f;
    let approvalReqs = [];
    if (jurisdictionData) {
        if (!((_b = (_a = jurisdictionData === null || jurisdictionData === void 0 ? void 0 : jurisdictionData.requirements) === null || _a === void 0 ? void 0 : _a.approvalReqs) === null || _b === void 0 ? void 0 : _b.includes(requirement)) &&
            !((_d = (_c = jurisdictionData === null || jurisdictionData === void 0 ? void 0 : jurisdictionData.requirements) === null || _c === void 0 ? void 0 : _c.submittalReqs) === null || _d === void 0 ? void 0 : _d.includes(requirement))) {
            if ((_e = jurisdictionData === null || jurisdictionData === void 0 ? void 0 : jurisdictionData.requirements) === null || _e === void 0 ? void 0 : _e.approvalReqs) {
                approvalReqs = [
                    ...(_f = jurisdictionData === null || jurisdictionData === void 0 ? void 0 : jurisdictionData.requirements) === null || _f === void 0 ? void 0 : _f.approvalReqs,
                    requirement,
                ];
            }
            else {
                approvalReqs = [requirement];
            }
        }
    }
    return approvalReqs;
};
//# sourceMappingURL=index.js.map